"use client";
import { useMemo } from "react";
import { useAuthQuery } from "@stadium/services/apollo-client";

import { fetchAddressList } from "@stadium/checkout/src/graphql/queries/fetch-address-list";

const emptyArr = [];

const useFetchSavedAddressesList = ({ skip = false } = {}) => {
  const { data, loading, refetch } = useAuthQuery(fetchAddressList, {
    skip,
    fetchPolicy: "cache-and-network",
  });

  const savedAddresses = useMemo(() => {
    return loading ? emptyArr : data?.addresses || emptyArr;
  }, [loading, data]);

  return { loading, savedAddresses, refetch };
};

export default useFetchSavedAddressesList;
